import React, { useState } from 'react';
import { Box, Button, CircularProgress, Container, Paper, Typography } from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

const NotAuthorized: React.FC = () => {
  const navigate = useNavigate();
  const { logout } = useAuth();
  const [loggingOut, setLoggingOut] = useState(false);

  const handleReturnToLogin = async () => {
    setLoggingOut(true);
    try {
      await logout();
    } catch {
      // ignore
    } finally {
      navigate('/login');
    }
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        bgcolor: 'background.default',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Container maxWidth="sm">
        <Paper
          elevation={0}
          sx={{
            p: { xs: 4, sm: 6 },
            textAlign: 'center',
            border: '1px solid',
            borderColor: 'divider',
            borderRadius: 2,
          }}
        >
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              mb: 3,
            }}
          >
            <Box
              sx={{
                width: 80,
                height: 80,
                borderRadius: '50%',
                bgcolor: 'error.light',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <LockOutlinedIcon sx={{ fontSize: 40, color: 'error.contrastText' }} />
            </Box>
          </Box>

          <Typography variant="h5" fontWeight={700} gutterBottom>
            Access Restricted
          </Typography>

          <Typography variant="body1" color="text.secondary" gutterBottom>
            Your account is not authorized to access this application.
          </Typography>

          <Typography variant="body2" color="text.secondary" sx={{ mt: 1, mb: 4 }}>
            If you believe this is a mistake, please contact your system administrator
            to request access.
          </Typography>

          <Button
            variant="contained"
            size="large"
            disabled={loggingOut}
            onClick={handleReturnToLogin}
            sx={{ minWidth: 180 }}
          >
            {loggingOut ? <CircularProgress size={24} color="inherit" /> : 'Return to Login'}
          </Button>
        </Paper>
      </Container>
    </Box>
  );
};

export default NotAuthorized;
